import type { AutoscaleRule, AutoscaleRulesResponse } from '../../hooks/useAutoscaleRulesQuery';

export function removeRuleFromResponse(
  data: AutoscaleRulesResponse | undefined,
  rule: Pick<AutoscaleRule, 'ruleId' | 'accountId'>
) {
  if (!data) {
    return data;
  }
  const rules = data.rules.filter(
    (r) => !(r.ruleId === rule.ruleId && r.accountId === rule.accountId)
  );
  if (rules.length === data.rules.length) {
    return data;
  }
  return { ...data, rules, count: Math.max(0, data.count - (data.rules.length - rules.length)) };
}
